import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextBlock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-block"} maskId="square-filled-radius-0-stroke-1-IconTextBlock"><path d="M12 5V6H21V5H12Z" fill="currentColor"/><path d="M12 8V9H18V8H12Z" fill="currentColor"/><path d="M12 15V16H21V15H12Z" fill="currentColor"/><path d="M12 18V19H18V18H12Z" fill="currentColor"/><path d="M3 4V10H9V4H3Z" fill="currentColor"/><path d="M3 14V20H9V14H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextBlock;
